<template>
  <div class="cp-floor-drz">
    <vue-dropzone v-if="!loading"
                  ref="myVueDropzone"
                  id="dropzone"
                  :options="dropzoneOptions"
                  @vdropzone-success="onSuccess"
    />
    <div class="upload-cancel">
      <CommonButton type="outline-danger" v-if="!loading && this.isChange" @click="handleCancel">{{
          $t("label.cancel")
        }}
      </CommonButton>
    </div>
    <loading color="#45adff" :active="loading" :is-full-page="false" loader="dots"/>
  </div>
</template>
<script>
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import vueDropzone from "vue2-dropzone";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from 'axios';
import CommonButton from "@/components/buttons/CommonButton.vue";

export default {
  name: 'ChargingStationMap',
  components: {CommonButton, vueDropzone, Loading},
  props: {
    locId: {
      type: String,
      required: true,
    },
    isChange: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: false,
      dropzoneOptions: {
        url: '/',
        maxFilesize: 10,
        thumbnailWidth: 0,
        acceptedFiles: 'image/*',
        dictDefaultMessage: "<i class='fa fa-cloud-upload'></i>",
      }
    }
  },
  mounted() {
    const dropzone = this.$refs.myVueDropzone.dropzone;
    const locId = this.locId;
    const self = this;
    dropzone.uploadFiles = async function (files) {
      for (const file of files) {
        self.loading = true;
        const parts = file.name.split('.');
        const type = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
        try {
          const {upload_url, relative_path, path} = await self.getUploadUrl(locId, type, file.type);
          await axios.put(upload_url, file)
          self.$emit('upload-done', {relative_path, path});
        } catch (err) {
          console.error(err);
          self.$message({
            message: self.$t("error.generic"),
            type: 'error'
          });
          self.loading = false;
        }
      }
    }
  },
  methods: {
    onSuccess() {
      console.log('')
    },
    async getUploadUrl(locId, fileType, contentType) {
      const res = await this.$axios.get(`/cp_locs/${locId}/floor-plan/get-upload-url?file_type=${fileType}&content_type=${contentType}`);
      return res.data;
    },
    handleCancel() {
      this.$emit('cancel-change-floor-plan');
    }

  }
}
</script>
<style lang="scss">
@import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");

.cp-floor-drz {
  width: 60vw;
  height: 100%;

  .vue-dropzone {
    height: 100%;
    padding: 0;
    border-radius: 8px;
    border: dashed 2px #a6a9ad;
    display: flex;
    align-items: center;
    justify-content: center;

    .dz-preview {
      margin: 0;
    }

    i {
      font-size: 50px;
      color: #bfbfbf;
    }
  }

  .upload-cancel {
    width: 100%;
    display: flex;
    margin-top: 5px;
    justify-content: end;
  }
}
</style>
